import { useMemo } from "react";
import { useIntlFormatterLocales } from "./useIntlFormatterLocales";

export function useRelativeTimeFormatter() {
  const defaultLocales = useIntlFormatterLocales();
  return useMemo(() => {
    const formatter = new Intl.RelativeTimeFormat(defaultLocales, {
      style: "short",
    });
    return (value: number, unit: Intl.RelativeTimeFormatUnit) => {
      return formatter.format(value, unit);
    };
  }, [defaultLocales]);
}
